import React, { Component } from 'react';
import style from '../css/module/queryTimer.css';
import flex from '../css/module/flex.css';
import AjaxSpinner from './AjaxSpinner';
import { setLoadingTimer } from '../actions/actions-misc';

class QueryTimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timer: '0.00',
    };
    this.updateTimer = this.updateTimer.bind(this);
  }

  componentDidMount() {
    const { onInteraction, timerStart } = this.props;
    if (onInteraction) {
      this.updateTimer(timerStart);
    }
  }

  componentWillUnmount() {
    const { onInteraction } = this.props;

    if (onInteraction) {
      // record new time
      onInteraction(setLoadingTimer(this.state.timer));
      // clear up
    }
    clearInterval(this._interval);
  }

  componentDidUpdate(prevProps) {
    if (this.props.timerStart !== prevProps.timerStart) {
      this.updateTimer(this.props.timerStart);
    }
  }

  updateTimer(timerStart) {
    if (this._interval) {
      clearInterval(this._interval);
    }
    this._interval = setInterval(() => {
      const elapsedTime = `${((Date.now() - timerStart) / 1000).toFixed(1)}0`;
      this.setState({
        timer: elapsedTime,
      });
    }, 100);
  }

  loadTips() {
    window.open(
      'https://guide.trevor.io/hc/en-us/articles/6173317232157-Speed-up-slow-queries',
      '_blank', //
    );
  }

  render() {
    const { onInteraction } = this.props;
    const { timer } = this.state;

    if (!onInteraction) {
      return (
        <div style={{ marginTop: '-15px', marginBottom: '10px' }}>
          <AjaxSpinner small />
        </div>
      );
    }

    return (
      <div className={`${flex.column} ${flex.alignItemsCenter}`}>
        <p style={{ marginTop: '20px' }}>
          <b>Awaiting results from your database</b>
        </p>
        <div
          style={{ marginBottom: '20px' }}
          className={`${flex.row} ${flex.alignItemsCenter}`}
        >
          <AjaxSpinner small />
          <div className="faint">Running for {timer}s</div>
        </div>
        {timer < 30 ? null : (
          <div
            style={{ textDecoration: 'underline' }}
            className={style.note}
            onClick={this.loadTips}
          >
            <img width="25" height="25" src="/img/runner.png" />
            Tips to speed up your queries
          </div>
        )}
      </div>
    );
  }
}

export default QueryTimer;
